export function isSettledStatus(status) {
    return status !== "Open" && status !== "Unknown";
}
//# sourceMappingURL=isSettledStatus.js.map